import React from 'react';
import styles from '@base/features/user/styles/userInfoMenu.module.scss';
import { Routes } from './routes';
import { container } from 'tsyringe';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { t } from '@base/utils/helpers';
import { IUserService } from '@base/features/user/model/interfaces';
import { Loader } from '@ui-kit/components/loader';
import { objectKeys } from '@utils/functions';
import { History } from 'history';
import MainButton from '@ui-kit/components/mainButton';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { useAvatar } from '@base/ui/hooks/useAvatar';
import { useAsyncData } from '@utils/hooks';

export default function UserInfoMenu() {
  const userService: IUserService = container.resolve('userService');
  const { data: personalInfo } = useAsyncData(userService.getUserInfo.bind(userService));
  const [avatar, isLoaded] = useAvatar();
  const { url } = useRouteMatch();
  const history: History = container.resolve('history');

  return (
    <div className={styles.menu}>
      <div className={styles.avatar}>
        {isLoaded ? <img src={avatar} alt={personalInfo?.login_name} /> : <Loader />}
      </div>
      <h1>{personalInfo?.login_name}</h1>
      <nav>
        {objectKeys(Routes).map((key) => (
          <NavLink key={key} activeClassName={styles.active} to={url + '/' + Routes[key]}>
            {t(Routes[key])}
          </NavLink>
        ))}
      </nav>
      <MainButton
        onClick={() =>
          history.push(personalInfo ? MAIN_ROUTES.editAccount : MAIN_ROUTES.completeRegistration)
        }
      >
        {t('edit_account')}
      </MainButton>
    </div>
  );
}
